<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_height">
					<v-row class="ma-0 pa-0" align="center">
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="back_clean_btn" width="6rem" height="50px"
								class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
								@click="goCameraStatus">
								{{tc('headerTitle')}}
							</v-btn>
						</v-col>
						<v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
							src="@/assets/images/history_arrow.png"></v-img>
						<v-col class="ma-0 pa-0" cols="auto">
							{{tc('headerMaintenance')}}
						</v-col>
					</v-row>
					<v-row class="ma-0 pa-0" align="center" justify="end">
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="blue_btn" width="10rem" height="2rem"
								class="ma-0 pa-0" elevation="0" style="font-size:0.9rem;" @click="requestSave">
								{{tc('save')}}
							</v-btn>
						</v-col>
          </v-row>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9" cols="10">
				<v-col id="setting_btn1" class="ma-0 pa-0 setting_btn" cols="12">
          <v-row class="ma-0 pa-4" align="center" justify="space-between">
            <v-col class="ma-0 pa-0" cols="auto">{{tc('faceRecoqThreshold')}}</v-col>
            <v-col class="ma-0 pa-0 pr-3" cols="2">
              <v-select class="ma-0 pa-0" v-model="selectedThreshold"
								:items="thresholdList" dense hide-details outlined
								dark item-text="label" item-value="value"
							></v-select>
            </v-col>
          </v-row>
				</v-col>
      </v-col>
		</v-col>
	</v-container>
</template>
<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    cameraDetail: {},
		selectedThreshold: '',
	}),
	computed: {
		thresholdList() {
			return [
				{ label: 'LOW', value: 'LOW' },
				{ label: 'MIDDLE', value: 'MIDDLE' },
				{ label: 'HIGH', value: 'HIGH' },
			];
		},
	},
	created() {
	},
	mounted() {
    this.cameraDetail = this.$route.query.detail;
    this.selectedThreshold = this.cameraDetail.thresholdLevel;
    // refresh를 하면 cameraDetail 정보도 초기화 된다.
    if (!this.selectedThreshold) this.goCameraStatus();
	},
	methods: {
    ts(t) {
      return this.$t("lang.settings." + t);
    },
    tc(t) {
      return this.$t("lang.cameraStatus." + t);
    },
		requestSave() {
			this.$dialog.confirm({
				title: this.ts('changeConfig'),
				text: this.ts('askChangeConfig'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: 'white', text: this.ts('changeAndSave'),
						handle: () => {
							this.$vloading.show();
							this.requestUpdateChanges();
						}
					}
				}
			});
		},
		requestUpdateChanges() {
      const { contractCd, portNo } = this.cameraDetail;
      const params = {
        level: this.selectedThreshold
      }
			this.networkController.updateThresholdLevel(params, contractCd, portNo).then(async (res) => {
				this.$vloading.hide();
				this.showToastMessage(this.tmb('saved'));
        // 성공 메시지를 표시한 후 2.5초(2500밀리초) 뒤에 this.goCameraStatus()를 호출합니다.
        setTimeout(() => {
          this.goCameraStatus();
        }, 2500);

			}).catch(error => {
				this.$vloading.hide();
				this.showToastMessage(this.tmb('requestFail'));
			});
		},
    goCameraStatus() {
      this.pushRoute('/camera-status', {});
    },
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_height {
	height: 50px;
}
.setting_btn {
	border-top: 1px solid #707070;
	font-family: note-sans-jp-medium, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
	font-size: 0.9rem;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem;
	color: white;
	font-size: 0.9rem;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep{
	.v-text-field>.v-input__control>.v-input__slot:before {
		border-style: none;
	}
	.v-text-field>.v-input__control>.v-input__slot:after {
		border-style: none;
	}
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		background: #272727;
	}
	.v-list-item__content{
		color: white;
	}
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>